export const DEFAULT_PAGESIZE = 16;
export const DEFAULT_TABLE_SIZE = 12;
export const DEFAULT_VIEWS_SIZE = 10;
export const DEFAULT_REPORTS_SIZE = 10;
export const DEFAULT_POSTS_SIZE = 20;
export const DEFAULT_SLIDER_POSTS_SIZE = 5;
